import { Paper, Typography } from '@mui/material'

import { Box, InfoRow } from '@/components/ui'
import type { OrganizationDetail } from '@/definitions/organization'
import { formatTaxRateFractionAsPercent } from '@/utils/taxRateUtils'

interface BillingTaxSectionProps {
  org: OrganizationDetail
}

export const BillingTaxSection = ({ org }: BillingTaxSectionProps) => {
  return (
    <Paper variant='detailCard'>
      <Box variant='flexColumn' gap='sm'>
        <Typography variant='overline' color='text.secondary'>
          Billing &amp; Tax
        </Typography>

        <Box variant='flexColumn' gap='sm'>
          <InfoRow
            label='Federal Tax ID'
            value={org.federal_tax_id ?? ''}
            tooltip='Employer Identification Number (EIN) issued by the IRS'
          />
          <InfoRow label='Tax Type' value={org.federal_tax_type ?? ''} />
          <InfoRow label='Tax Rate' value={formatTaxRateFractionAsPercent(org.tax_rate)} />
        </Box>
      </Box>
    </Paper>
  )
}
